export enum FEATURE_NAMES {
  cs = 'cs',
  pop = 'pop',
  dg = 'dg',
  mt = 'moving_text',
  template = 'template',
}
